var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 71C55.1061 71 71 55.1061 71 35.5C71 15.8939 55.1061 0 35.5 0C15.8939 0 0 15.8939 0 35.5C0 55.1061 15.8939 71 35.5 71Z",
    fill: "#1C9D6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3555 32.7373H31.3951V39.2564C31.3951 40.8184 32.3504 41.8511 33.9253 41.8511C35.5002 41.8511 36.4555 40.8184 36.4555 39.2564V32.7373H38.4951V39.3984C38.4951 41.864 36.8557 43.8133 33.9253 43.8133C30.9949 43.8133 29.3555 41.864 29.3555 39.3984V32.7373Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0718 32.7373V43.5809H42.0063V32.7373H44.0718Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUi);
export default __webpack_public_path__ + "static/media/ui.bd9950140a35b4dc96bd3de69ff8adeb.svg";
export { ForwardRef as ReactComponent };